<script setup>
const props = defineProps({
  pointInfo: {
    type: Object,
    default: () => ({})
  }
})

useCustomMeta('cam', props.pointInfo.Name, props.pointInfo.RiverNm)
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb('point', props.pointInfo.Name)
const { data: detailData } = await useAsyncData(
  `riverDetailData-${props.pointInfo.CameraID}`,
  () => $fetch('https://aplapi.weathernews.jp/lba/river/api_observatory_detail', {
    query: {
      camera_id: props.pointInfo.CameraID
    }
  }),
  { watch: [() => props.pointInfo.CameraID] }
)
watch(() => detailData.value, () => {
  window.scrollTo({ top: 0, behavior: 'instant' })
})
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <div class="head">
          <p class="tag">
            {{ makeInfo(props.pointInfo) }}
          </p>
          <CommonPageTitle :title="props.pointInfo.Name" />
        </div>
        <RiverCameraMovie
          :title="props.pointInfo.Name"
          :tag="makeInfo(props.pointInfo)"
          :camera-list="detailData.camera_list"
        />
      </div>
      <template #main-bottom>
        <RiverCameraStatic
          v-if="detailData.normal_img_url"
          :normal-url="detailData.normal_img_url"
        />
        <RiverComparison
          v-if="detailData.camera_list && detailData.camera_list.length > 1"
          :detail-data="detailData"
        />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <RiverAroundList
          :id="props.pointInfo.ID"
          :title="props.pointInfo.Name"
          :lat="props.pointInfo.Lat"
          :lon="props.pointInfo.Lon"
        />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
  }
  .tag {
    padding: 6px 10px;
    border-radius: 4px;
    background-color: #EEF1F8;
    color: #606060;
    font-size: 10px;
    font-weight: 600;
    line-height: 1em;
    letter-spacing: .25px;
  }
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
